import { render, staticRenderFns } from "./AreaDetailTable.vue?vue&type=template&id=ccf467ac&scoped=true&"
import script from "./AreaDetailTable.vue?vue&type=script&lang=js&"
export * from "./AreaDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf467ac",
  null
  
)

export default component.exports